import { render, staticRenderFns } from "./VehicleDashboard.vue?vue&type=template&id=c813a6d8&scoped=true"
import script from "./VehicleDashboard.vue?vue&type=script&lang=js"
export * from "./VehicleDashboard.vue?vue&type=script&lang=js"
import style0 from "./VehicleDashboard.vue?vue&type=style&index=0&id=c813a6d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c813a6d8",
  null
  
)

export default component.exports